import React, { useState, useEffect } from 'react';
import '../allcss/contect.css';
import Header from '../components/header';
import Footer from '../components/footer';
import { Helmet } from "react-helmet-async";




const ContactForm = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });

  const [formErrors, setFormErrors] = useState({});
  const [activeField, setActiveField] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleFocus = (field) => {
    setActiveField(field);
    setFormErrors(prev => ({ ...prev, [field]: '' }));
  };

  const handleBlur = () => {
    setActiveField('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (!formData.name.trim() || formData.name.length < 3) {
      newErrors.name = 'Please enter at least 3 characters.';
    }

    if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = 'Mobile number must be 10 digits.';
    }

    setFormErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    // ✅ Format message for WhatsApp
    const message = `*Name:* ${formData.name}%0A*Email:* ${formData.email}%0A*Mobile:* ${formData.mobile}%0A*Message:* ${formData.message}`;
    const phoneNumber = '917778851070'; // ✅ WhatsApp number in international format without + sign
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;

    // ✅ Open WhatsApp chat
    window.open(whatsappURL, '_blank');

    setStatusMessage('Redirecting to WhatsApp...');
    setStatusType('success');
    setFormData({ name: '', email: '', mobile: '', message: '' });
    setFormErrors({});
  };

  return (
    <>
       <Helmet>
        <link
          rel="canonical"
          href="https://www.redhouseschoolvadodara.in/contact"
        />
      </Helmet>
      
      <Header />
      <div className="ctf-container">
        <div className="ctf-header">
          <br />
          <div className="ctf-title">Contact RED School House</div>
      
        </div>

        <div id="ctf-form-wrapper">
          <div className="ctf-fish" id="ctf-fish1"></div>
          <div className="ctf-fish" id="ctf-fish2"></div>

          <form id="ctf-form" onSubmit={handleSubmit}>
            <div className={`ctf-group ${activeField === 'name' ? 'ctf-group-active' : ''} ${formErrors.name ? 'ctf-group-error' : ''}`}>
                  <br />
          <br />
          <br />
          <br />
              <div className="ctf-label">Name</div>
              <input
                type="text"
                className="ctf-input"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                onFocus={() => handleFocus('name')}
                onBlur={handleBlur}
              />
              {formErrors.name && <span className="ctf-error-text">{formErrors.name}</span>}
            </div>

            <div className={`ctf-group ${activeField === 'email' ? 'ctf-group-active' : ''} ${formErrors.email ? 'ctf-group-error' : ''}`}>
              <div className="ctf-label">Email Address</div>
              <input
                type="email"
                className="ctf-input"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                onFocus={() => handleFocus('email')}
                onBlur={handleBlur}
              />
              {formErrors.email && <span className="ctf-error-text">{formErrors.email}</span>}
            </div>

            <div className={`ctf-group ${activeField === 'mobile' ? 'ctf-group-active' : ''} ${formErrors.mobile ? 'ctf-group-error' : ''}`}>
              <div className="ctf-label">Mobile Number</div>
              <input
                type="tel"
                className="ctf-input"
                name="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                onFocus={() => handleFocus('mobile')}
                onBlur={handleBlur}
              />
              {formErrors.mobile && <span className="ctf-error-text">{formErrors.mobile}</span>}
            </div>

            <div className={`ctf-group ${activeField === 'message' ? 'ctf-group-active' : ''}`}>
              <div className="ctf-label">Message</div>
              <textarea
                className="ctf-textarea"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                onFocus={() => handleFocus('message')}
                onBlur={handleBlur}
              ></textarea>
            </div>

            <input
              type="submit"
              className="ctf-submit"
              value="Send Enquiry!"
            />

            {statusMessage && (
              <div className={`ctf-status ${statusType === 'success' ? 'success' : 'error'}`}>
                {statusMessage}
              </div>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactForm;
